// @ts-nocheck
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export type SetWarehouseParameter = {
    warehouse?: string | undefined;
};

type HandlerType = Handler<SetWarehouseParameter>;

export const DispatchSetReturnWarehouse: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/RequestRma/SetReturnWarehouse",
        warehouse: props.parameter.warehouse,
    });
};

export const chain = [DispatchSetReturnWarehouse];

const setReturnWarehouse = createHandlerChainRunner(chain, "SetReturnWarehouse");
export default setReturnWarehouse;
